import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './Servicos.css';

const Servicos = () => {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/registro');
  };

  const handleInvestClick = () => {
    navigate('/invista-conosco');
  };

  const services = [
    {
      title: "Compra de Precatórios",
      icon: <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>,
      description: "Adquira precatórios com as melhores condições do mercado. Análise por IA garante avaliação justa e pagamento rápido.",
      benefits: [
        "Análise automática por IA em minutos",
        "Pagamento em até 5 dias",
        "Proposta justa e transparente",
        "Processo 100% digital"
      ]
    },
    {
      title: "Consultoria Jurídica",
      icon: <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/></svg>,
      description: "Assessoria jurídica especializada em precatórios para tirar todas suas dúvidas e garantir segurança em cada etapa.",
      benefits: [
        "Equipe especializada em precatórios",
        "Suporte durante todo o processo",
        "Análise de documentação",
        "Orientação sobre direitos"
      ]
    },
    {
      title: "Análise por Inteligência Artificial",
      icon: <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor"><path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/></svg>,
      description: "Tecnologia de ponta para análise completa de precatórios, cálculo de valores e previsão de pagamento.",
      benefits: [
        "Análise instantânea de documentos",
        "Cálculo preciso com base em RCL",
        "Previsão de data de pagamento",
        "Validação automática de dados"
      ]
    },
    {
      title: "Gestão de Portfólio",
      icon: <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>,
      description: "Para investidores: gestão completa de portfólio de precatórios com monitoramento em tempo real.",
      benefits: [
        "Dashboard com métricas em tempo real",
        "Acompanhamento de todos os ativos",
        "Relatórios detalhados",
        "Alertas e notificações"
      ]
    }
  ];

  return (
    <div className="servicos-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section servicos-hero">
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                <div className="hero-badge">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
                  </svg>
                  Soluções Completas
                </div>

                <h1 className="hero-title">
                  Nossos<br />
                  <span className="highlight-text">Serviços</span>
                </h1>

                <p className="hero-subtitle">
                  Soluções tecnológicas e especializadas para todas as suas necessidades relacionadas a precatórios.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">O Que Oferecemos</h2>
            </div>

            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-benefits">
                    {service.benefits.map((benefit, idx) => (
                      <li key={idx}>{benefit}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title white-title">Como Funciona Nosso Processo</h2>
            </div>

            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <h3>Cadastro</h3>
                <p>Cadastre seu precatório em nosso sistema 100% digital</p>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-step">
                <div className="step-number">2</div>
                <h3>Análise IA</h3>
                <p>Nossa IA analisa e valida todos os dados automaticamente</p>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-step">
                <div className="step-number">3</div>
                <h3>Proposta</h3>
                <p>Receba uma proposta justa e transparente</p>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-step">
                <div className="step-number">4</div>
                <h3>Pagamento</h3>
                <p>Dinheiro na conta em até 5 dias</p>
              </div>
            </div>
          </div>
        </section>

        {/* Technology Section */}
        <section className="technology-section">
          <div className="container">
            <div className="technology-content">
              <div className="technology-text">
                <h2 className="section-title">Tecnologia de Ponta</h2>
                <p className="lead-text">
                  Nossa plataforma utiliza Inteligência Artificial e automação para revolucionar o mercado de precatórios.
                </p>
                <ul className="technology-features">
                  <li>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Extração automática de dados 24/7
                  </li>
                  <li>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Cálculos precisos com base em RCL
                  </li>
                  <li>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Análise de risco e validação jurídica
                  </li>
                  <li>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Dashboard com métricas em tempo real
                  </li>
                  <li>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    Cobertura de todos os 27 estados
                  </li>
                </ul>
                <button className="btn btn-primary btn-large" onClick={handleInvestClick}>
                  Conheça Nossa Tecnologia
                </button>
              </div>
              <div className="technology-stats">
                <div className="tech-stat">
                  <div className="tech-stat-number">99.9%</div>
                  <div className="tech-stat-label">Precisão da IA</div>
                </div>
                <div className="tech-stat">
                  <div className="tech-stat-number">5 dias</div>
                  <div className="tech-stat-label">Tempo médio de pagamento</div>
                </div>
                <div className="tech-stat">
                  <div className="tech-stat-number">24/7</div>
                  <div className="tech-stat-label">Processamento automático</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Pronto para Começar?</h2>
              <p className="cta-subtitle">
                Experimente nossos serviços e descubra como podemos ajudar você a realizar seus objetivos com precatórios.
              </p>
              <div className="cta-buttons">
                <button className="btn btn-primary btn-large" onClick={handleCTAClick}>
                  Vender Meu Precatório
                </button>
                <button className="btn btn-secondary btn-large" onClick={handleInvestClick}>
                  Quero Investir
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Servicos;
